// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[2]!./PositionFormModal.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import base modal styles */

/* Modal specific */
.manage-positions-modal {
  max-width: 600px;
  margin: 40px;
}

.manage-positions-modal .modal-body {
  padding: 20px 24px;
  max-height: 60vh;
  overflow-y: auto;
}

/* Member Info */
.member-info {
  padding: 16px;
  background: #f9fafb;
  border-radius: 8px;
  margin-bottom: 20px;
}

.member-info .info-row {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}

.member-info .info-row:last-child {
  margin-bottom: 0;
}

.member-info .label {
  font-weight: 600;
  color: #374151;
  min-width: 80px;
}

.member-info .value {
  color: #1f2937;
}

/* Positions Section */
.positions-section {
  margin-bottom: 24px;
}

.section-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 12px;
}

.section-label.clickable {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.positions-tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  min-height: 40px;
  padding: 12px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

.position-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: #eff6ff;
  color: #1e40af;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
}

.position-tag:hover {
  background: #dbeafe;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.tag-name {
  line-height: 1;
}

.tag-remove-btn {
  background: none;
  border: none;
  color: #ef4444;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  transition: all 0.2s;
}

.tag-remove-btn:hover {
  background: #fee2e2;
  color: #dc2626;
}

/* Add Position Section */
.add-position-section {
  margin-bottom: 20px;
}

.position-dropdown {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  background: white;
  cursor: pointer;
  transition: all 0.2s;
}

.position-dropdown:hover {
  border-color: #9ca3af;
}

.position-dropdown:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.empty-message {
  color: #9ca3af;
  font-size: 14px;
  font-style: italic;
  margin: 0;
  padding: 8px 0;
}

/* Modal Footer */
.manage-positions-modal .modal-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-top: 1px solid #e5e7eb;
}

.auto-save-note {
  font-size: 13px;
  color: #6b7280;
  margin: 0;
  font-style: italic;
}

.btn-done {
  padding: 10px 32px;
  background: #2563eb;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-done:hover {
  background: #1d4ed8;
}

/* Responsive */
@media (max-width: 768px) {
  .manage-positions-modal {
    margin: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ServePositions/ManagePositionsModal.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAG7B,mBAAmB;AACnB;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,YAAY;EACd;AACF","sourcesContent":["/* Import base modal styles */\n@import './PositionFormModal.css';\n\n/* Modal specific */\n.manage-positions-modal {\n  max-width: 600px;\n  margin: 40px;\n}\n\n.manage-positions-modal .modal-body {\n  padding: 20px 24px;\n  max-height: 60vh;\n  overflow-y: auto;\n}\n\n/* Member Info */\n.member-info {\n  padding: 16px;\n  background: #f9fafb;\n  border-radius: 8px;\n  margin-bottom: 20px;\n}\n\n.member-info .info-row {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.member-info .info-row:last-child {\n  margin-bottom: 0;\n}\n\n.member-info .label {\n  font-weight: 600;\n  color: #374151;\n  min-width: 80px;\n}\n\n.member-info .value {\n  color: #1f2937;\n}\n\n/* Positions Section */\n.positions-section {\n  margin-bottom: 24px;\n}\n\n.section-label {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 12px;\n}\n\n.section-label.clickable {\n  cursor: pointer;\n  user-select: none;\n}\n\n.positions-tags-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  min-height: 40px;\n  padding: 12px;\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n}\n\n.position-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: #eff6ff;\n  color: #1e40af;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n\n.position-tag:hover {\n  background: #dbeafe;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.tag-name {\n  line-height: 1;\n}\n\n.tag-remove-btn {\n  background: none;\n  border: none;\n  color: #ef4444;\n  font-size: 20px;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0;\n  width: 18px;\n  height: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 3px;\n  transition: all 0.2s;\n}\n\n.tag-remove-btn:hover {\n  background: #fee2e2;\n  color: #dc2626;\n}\n\n/* Add Position Section */\n.add-position-section {\n  margin-bottom: 20px;\n}\n\n.position-dropdown {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 14px;\n  background: white;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.position-dropdown:hover {\n  border-color: #9ca3af;\n}\n\n.position-dropdown:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.empty-message {\n  color: #9ca3af;\n  font-size: 14px;\n  font-style: italic;\n  margin: 0;\n  padding: 8px 0;\n}\n\n/* Modal Footer */\n.manage-positions-modal .modal-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 24px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.auto-save-note {\n  font-size: 13px;\n  color: #6b7280;\n  margin: 0;\n  font-style: italic;\n}\n\n.btn-done {\n  padding: 10px 32px;\n  background: #2563eb;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.btn-done:hover {\n  background: #1d4ed8;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .manage-positions-modal {\n    margin: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
